import styled from "styled-components";

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 25px;
  padding: 0 1px;
  overflow: scroll;
  height: 70vh;
`;

export const BoxDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #343536;
  }
`;

export const BtnFixed = styled.div`
  position: fixed;
  bottom: 15px;
  width: 93%;

  display: flex;
  flex-direction: row;
  gap: 25px;
  button {
    width: 100%;
  }
`;
